import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Paper, Popover, styled } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';
import { CompactPicker } from 'react-color';
import FlexBox from '../FlexBox';

const ColorPickerPaper = styled(Paper)(({ color, cursor }) => ({
  margin: '-0.5rem',
  width: '4rem',
  height: '2rem',
  border: '5px solid',
  borderColor: 'white',
  '&:hover': {
    cursor: cursor
  },
  backgroundColor: color
}));

const ColorPicker = ({ color, label, onChange, disabled }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = event => {
    if (!disabled) setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    if (!disabled) setAnchorEl(null);
  };

  const handleColorChange = color => {
    if (!disabled) onChange(color.hex);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'color-picker-popover' : undefined;

  return (
    <FlexBox gap={2} alignItems='center' width='fit-content'>
      {label && <Typography variant='body1'>{label}:</Typography>}
      <ColorPickerPaper elevation={5} aria-describedby={id} color={color} cursor={disabled ? 'auto' : 'pointer'} onClick={handleClick} />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <CompactPicker color={color ? color : '#FFFFFF'} onChange={handleColorChange} />
      </Popover>
    </FlexBox>
  );
};

ColorPicker.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default ColorPicker;
